/**
 * API / static asset origin is chosen from where the app is loaded (no manual swaps per deployment).
 * - localhost / 127.0.0.1 → local API http://localhost:52476 by default
 * - If REACT_APP_DEV_API_PROXY is set (e.g. https://api.nscholar.com), localhost uses same-origin
 *   paths (empty origin) so src/setupProxy.js can forward /api and avoid browser CORS errors.
 * - newacc.dpskasur.edu.pk → production API (nscholar)
 * - dpsserver or 192.168.1.99 → LAN server API (fixed host:port as used by the backend)
 */
function getApiOrigin() {
  if (typeof window === "undefined") {
    return "http://localhost:52476";
  }

  const { hostname } = window.location;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const devProxy =
      typeof process !== "undefined" &&
      process.env.REACT_APP_DEV_API_PROXY &&
      String(process.env.REACT_APP_DEV_API_PROXY).trim();
    if (devProxy) {
      return "";
    }
    return "http://localhost:52476";

    //  return "https://api.nscholar.com";
  }

  if (hostname === "newacc.dpskasur.edu.pk") {
    return "https://api.nscholar.com";
  }

  if (hostname === "dpsserver" || hostname === "192.168.1.99") {
    return "http://192.168.1.99:8072";
  }

  // Unknown host: same origin as the app (useful if you add a host later without editing this file)
  return `${window.location.protocol}//${window.location.host}`;
}

const apiOrigin = getApiOrigin();

const config = {
  date_format: "DD/MM/YYYY",
  date_format_input: "YYYY-MM-DD",
  library_fine_per_day: 10,
  post_library_fine_to_challan: true,
  library_fine_fee_code: "",
  libraryImagesPath: `${apiOrigin}/library_images/`,

  Editor_Apikey:
    "w81u1otpwt8qqd0odorwvyaol3vsrjipuhdua1mr6kjqnebw",

  base_url: `${apiOrigin}/api/`,
  StaffImagePath: `${apiOrigin}/staff_images/`,
  StudentImagePath: `${apiOrigin}/student_images/`,
  images: `${apiOrigin}/images/`,
  assets: `${apiOrigin}/assets/`,
  root: `${apiOrigin}/`,
};

export default config;


// new password :Aabcde@786
  // new password :Pakistan